import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-about-avaana',
  templateUrl: './about-avaana.html',
  styleUrls: ['./about-avaana.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AboutAvaanaComponent {}
